import Blue from '~/core'

new Blue({
  name: 'Header Desktop Nav Menu',
  selector: '.header__nav',
  setup(headerNav) {
    if (this.$screen.xl) {
      const navItems = [...headerNav.querySelectorAll('.header__nav-item')]

      navItems.forEach((item) => {
        item.setAttribute('tabindex', '0')
        this.$addEvents(item, 'mouseover', () => {
          if (item.classList.contains('is-hover')) {
          } else {
            item.classList.add('is-hover')
          }
        })
        this.$addEvents(item, 'mouseout', () => {
          item.classList.remove('is-hover')
        })
        this.$addEvents(item, 'enter', () => {
          if (item.classList.contains('focused')) {
            item.classList.remove('focused')
          } else {
            item.classList.add('focused')
          }
        })
        this.$addEvents(item, 'escape', () => {
          item.classList.remove('focused')
        })
      })
    }
  },
})

new Blue({
  name: 'Header Mobile Nav Menu',
  selector: '.header',
  setup(header) {
    const content = header.querySelector('.header__inner')
    const trigger = header.querySelector('.header__nav-trigger')
    const nav = header.querySelector('.header__nav')
    const navList = nav.querySelector('.header__nav-list')
    const ctas = header.querySelector('.header__ctas')
    const actions = [...header.querySelectorAll('.header__action')]
    const language = header.querySelector('.header__language')

    const topLevelItems = [...header.querySelectorAll('.header__nav-item')]
    const secondLevelItems = [
      ...header.querySelectorAll('.header__nav-primary-item:not(.header__nav-primary-item--img)'),
    ]

    const backTranslation = header.dataset.translateBackLink

    const initLayout = () => {
      if (ctas) {
        this.$retach(ctas, {
          destination: nav,
          mediaQuery: this.$screen.xl_dn,
          movedClass: 'is-mobile',
          moveMethod: 'append',
        })
      }

      this.$retach(language, {
        destination: navList,
        mediaQuery: this.$screen.xl_dn,
        movedClass: 'is-mobile',
        moveMethod: 'append',
        wrapper: 'li',
        wrapperClass: 'header__nav-item',
      })

      actions.forEach((action) => {
        this.$retach(action, {
          destination: navList,
          mediaQuery: this.$screen.xl_dn,
          movedClass: 'is-mobile',
          moveMethod: 'append',
          wrapper: 'li',
          wrapperClass: 'header__nav-item',
        })
      })
    }

    const initSecondLevelMobileItems = (item) => {
      const label = item.closest('.header__nav-item').querySelector('.header__nav-label').textContent
      const button = item.querySelector('.header__nav-primary-heading')
      const menu = item.querySelector('.header__nav-primary-menu')

      const open = (e) => {
        if (this.$screen.xl.matches) return
        e.preventDefault()
        item.classList.add('is-open')
      }
      const close = (e) => {
        e.preventDefault()
        e.stopPropagation()
        item.classList.remove('is-open')
      }

      const backButton = this.$createElement({
        tag: 'button',
        attributes: {
          class: 'header__nav-primary-back',
        },
        text: `${backTranslation} ${label}`,
      })

      const backLi = this.$createElement({
        tag: 'li',
        attributes: {
          class: 'header__nav-primary-item header__nav-primary-item--back',
        },
      })

      this.$addEvents(button, 'click.stop.prevent', open)
      this.$addEvents(backButton, 'click.stop.prevent', close)

      backLi.insertAdjacentElement('afterbegin', backButton)
      menu.insertAdjacentElement('afterbegin', backLi)
    }

    const initTopLevelMobileItems = (item) => {
      const link = item.querySelector('.header__nav-label')
      const menu = item.querySelector('.header__nav-primary')

      const open = (e) => {
        if (this.$screen.xl.matches) return
        e.preventDefault()
        item.classList.add('is-open')
      }

      const close = (e) => {
        const item = e.target.closest('.header__nav-item')
        item.classList.remove('is-open')
      }

      const ul = this.$createElement({
        tag: 'ul',
        attributes: {
          class: 'header__nav-primary-list header__nav-primary-list--mobile-actions',
        },
      })

      const backButton = this.$createElement({
        tag: 'button',
        attributes: {
          class: 'header__nav-primary-back',
        },
        text: `${backTranslation}`,
      })

      const backLi = this.$createElement({
        tag: 'li',
        attributes: {
          class: 'header__nav-primary-item header__nav-primary-item--back',
        },
      })

      this.$addEvents(link, 'click', open)
      this.$addEvents(backButton, 'click.stop.prevent', close)

      backLi.insertAdjacentElement('afterbegin', backButton)
      // viewAllLi.insertAdjacentElement('afterbegin', viewAllLink);
      // ul.insertAdjacentElement('afterbegin', viewAllLi);
      ul.insertAdjacentElement('afterbegin', backLi)
      if (menu) {
        menu.insertAdjacentElement('afterbegin', ul)
      }
    }

    const toggle = () => {
      let height = content.offsetHeight
      nav.style.top = `${height}px`
      header.classList.toggle('is-active')

      if (header.classList.contains('is-active')) {
        this.$scrollLock.lock(nav)
      } else {
        this.$scrollLock.unlock(nav)
      }
    }

    const resizing = () => {
      let height = content.offsetHeight
      header.style.marginBottom = `${height}px`
      this.$scrollLock.clear()
      header.classList.remove('is-active')
      ;[...header.querySelectorAll('.is-open')].forEach((e) => e.classList.remove('is-open'))
    }

    const init = () => {
      initLayout()
      if (!nav.classList.contains('header__nav--simple')) {
        topLevelItems.forEach(initTopLevelMobileItems)
      }
      secondLevelItems.forEach(initSecondLevelMobileItems)

      this.$addEvents(trigger, 'click', toggle)
      this.$addEvents(window, 'resize', resizing)
    }

    init()
    resizing()
  },
})

new Blue({
  name: 'Header Utility Nav Menu',
  selector: '.header__language',
  setup(lang) {
    const trigger = lang.querySelector('.header__language-active')
    const menu = lang.querySelector('.header__language-menu')

    const backTranslation = lang.dataset.translateBackLink

    const initMobileMenu = () => {
      const open = () => {
        if (this.$screen.matches) return
        lang.classList.add('is-open')
      }
      const close = () => {
        if (this.$screen.matches) return
        lang.classList.remove('is-open')
      }
      const backButton = this.$createElement({
        tag: 'button',
        attributes: {
          class: 'header__language-back',
        },
        text: `${backTranslation}`,
      })

      this.$addEvents(trigger, 'click.stop.prevent', open)
      this.$addEvents(backButton, 'click.stop.prevent', close)

      menu.insertAdjacentElement('afterbegin', backButton)
    }

    const toggle = () => {
      if (!this.$screen.xl.matches) return
      let start = {}
      let end = {}

      start.height = menu.offsetHeight
      start.visibility = getComputedStyle(menu).visibility
      lang.classList.toggle('is-active')
      end.height = menu.offsetHeight
      end.visibility = getComputedStyle(menu).visibility

      menu.animate(
        [
          {
            height: `${start.height}px`,
            visibility: `${start.visibility}`,
          },
          {
            height: `${end.height}px`,
            visibility: `${end.visibility}`,
          },
        ],
        {
          duration: 250,
          easing: 'ease',
        },
      )
    }
    initMobileMenu()
    this.$addEvents(trigger, 'click.stop.prevent enter.stop.prevent', toggle)
    this.$addEvents(document.body, 'click', (e) => {
      if (e.target.closest('.header__language')) return
      lang.classList.remove('is-active')
    })
  },
})
